import { makeObservable, observable, action } from 'mobx'
import { BaseFieldStore } from './BaseFieldStore'
import { IFieldDefinition } from './Types/FieldTypeEnum'
import { FieldStoreFactory } from './FieldStoreFactory'

/**
 * Поле для объектов с вложенными полями
 */
export class ObjectFieldStore extends BaseFieldStore {
    nestedFields: Map<string, BaseFieldStore> = new Map()

    constructor(definition: IFieldDefinition, formContext: any, path: string[] = []) {
        super(definition, formContext, path)

        makeObservable(this, {
            nestedFields: observable,
            createNestedFields: action,
        })

        this.createNestedFields()

        // Инициализируем пустым объектом если не задано
        if (this.value === undefined) {
            this.setValue({})
        }
    }

    /**
     * Создать вложенные поля
     */
    createNestedFields(): void {
        if (this.definition.fields) {
            Object.entries(this.definition.fields).forEach(([fieldName, fieldDef]) => {
                const fieldDefinition: IFieldDefinition = {
                    ...fieldDef,
                    name: fieldName,
                    strategy:
                        fieldDef.strategy ||
                        FieldStoreFactory.inferStrategy(fieldDef as IFieldDefinition),
                } as IFieldDefinition

                const nestedField = FieldStoreFactory.createField(
                    fieldDefinition,
                    this.formContext,
                    this.path
                )
                this.nestedFields.set(fieldName, nestedField)
            })
        }
    }

    /**
     * Получить вложенное поле
     */
    getNestedField(name: string): BaseFieldStore | undefined {
        return this.nestedFields.get(name)
    }

    /**
     * Получить все вложенные поля
     */
    getNestedFields(): BaseFieldStore[] {
        return Array.from(this.nestedFields.values())
    }

    /**
     * Установить значение вложенного поля
     */
    setNestedValue(fieldName: string, value: any): void {
        const nestedPath = [...this.path, fieldName]
        this.formContext.setValue(nestedPath, value)
    }

    /**
     * Получить значение вложенного поля
     */
    getNestedValue(fieldName: string): any {
        const nestedPath = [...this.path, fieldName]
        return this.formContext.getValue(nestedPath)
    }

    /**
     * Валидация объектного поля
     */
    validate(): boolean {
        let isValid = super.validate()

        // Валидируем все вложенные поля
        this.nestedFields.forEach((field) => {
            if (!field.validate()) {
                isValid = false
            }
        })

        return isValid
    }
}
